import { useState, useEffect } from 'react'

import { CUPCAKE, TOMATO } from 'constants/socket'
import { greetingEventEmitter, greetingKeys } from 'helpers/events'
import { randomize } from 'utils/utils'

const IMAGE_BASE = '/img/tiles/greetings'

const useCreateSplotch = (uuid, teacher) => {
    const [splotches, addSplotch] = useState([])
    const actionToTrigger = (teacher ? CUPCAKE : TOMATO).toUpperCase()

    useEffect(() => {
        const handleGreeting = greetings => {
            const { reciever } = greetings

            reciever === uuid && handleCreateSplotch()
        }

        greetingEventEmitter.addListener(
            greetingKeys[actionToTrigger],
            handleGreeting
        )

        return () =>
            greetingEventEmitter.removeListener(
                greetingKeys[actionToTrigger],
                handleGreeting
            )
    }, [])

    const handleCreateSplotch = () => {
        const area = 60
        const verticalPosition = 15 + Math.round(Math.random() * area) // not to start with have first 15% of tile
        const horizontalPosition = 15 + Math.round(Math.random() * area)

        const rotate = randomize(0, 270) // deg

        const src = teacher
            ? `${IMAGE_BASE}/cupcake-splotch.svg`
            : `${IMAGE_BASE}/tomato-splotch-${randomize(1, 3)}.svg`

        addSplotch(splotches => [
            ...splotches,
            { top: verticalPosition, right: horizontalPosition, rotate, src },
        ])
    }

    return splotches
}

export default useCreateSplotch
